export enum WorkOrderProgressStep {
	Info,
	Contact,
	Schedule,
	UploadWOC,
	Complete
}